import { Trans } from '@lingui/macro'
import React from 'react'
import { InputField } from 'webbook-airways'

export default function InputFieldPostalCode(props) {
  return (
    <InputField
      css={{ width: 100 }}
      autoComplete="new-password"
      label={<Trans>Postal code</Trans>}
      {...props}
    />
  )
}
